<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed z-50 inset-0 overflow-y-auto" @close="open = false">
            <div class="flex sm:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-8/12 sm:p-6">
                        <filter-types-select @changed="filtersChanged" :checked-filter="rule ? rule.type : null" :excluded-filters="excludedFilters"></filter-types-select>
                        <component class="mt-2" v-if="rule" :is="rule.type" v-model="rule.data"></component>
                        <div class="mt-4">
                            <button type="button"
                                    v-if="rule.type && Object.keys(this.rule.data).length > 0"
                                    @click="save"
                                    class="mr-2 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Сохранить
                            </button>
                            <button type="button"
                                    @click="cancel"
                                    class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Отменить
                            </button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { ref } from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/24/outline'
import FilterTypesSelect from "./FilterTypesSelect.vue";
import Device from "./filters/Device.vue";
import Day from "./filters/Day.vue";
import Time from "./filters/Time.vue";
import ScansCount from "./filters/ScansCount.vue";
import Language from "./filters/Language.vue";
import Location from "./filters/Location.vue";
import {mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
        FilterTypesSelect,
        Device,
        Day,
        Time,
        ScansCount,
        Language,
        Location
    },

    mounted() {
        this.emitter.on("toggle-qr-condition-modal", (modalData) => {
            if (modalData.rule) {
                this.rule = Object.assign({}, modalData.rule)
            } else {
                this.rule = {type: null, data: {}}
            }

            this.modalData = modalData
            this.open = true

            this.excludedFilters = this.code.destinations[this.modalData.destinationId].rules.filter(rule => {
                return this.rule === null || rule.type !== this.rule.type
            })
        });
    },

    data() {
        return {
            open: false,
            selectedFilters: [],
            rule: null,
            modalData: null,
            excludedFilters: []
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code'])
    },

    methods: {
        save() {
            if (Object.keys(this.rule.data).length === 0) {
                return
            }

            this.open = false
            this.emitter.emit("toggle-qr-condition-modal-save", {
                destinationId: this.modalData.destinationId,
                ruleId: this.modalData.ruleId,
                rule: this.rule
            });
        },

        cancel() {
            this.open = false
        },

        filtersChanged(filter) {
            this.rule = {type: filter, data: {}}
        }
    }
}
</script>
